import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CfetBaseComponent, CfetPageNamesConstant } from '../../../cfet-core';
import { Router } from '@angular/router';
import { environment } from './../../../../environments/environment';

@Component({
    selector: 'app-skip-for-now-modal',
    templateUrl: './skip-for-now-modal.component.html',
    styleUrls: ['./skip-for-now-modal.component.scss'],
    standalone: false
})
export class SkipForNowModalComponent extends CfetBaseComponent {

  constructor(private router: Router) { super(); }

  @Input() openModal: string;
  @Input() selectedFile: string;
  @Output() modalCloseEvent = new EventEmitter<any>();

  skipUploadForNow(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      sessionStorage.setItem('skipDocUpload',"true");
      const url = environment.getBrowserPath() + CfetPageNamesConstant.CUSTOMER_PROFILE;
      this.redirectUrl(url);
    }
  }

  redirectUrl(url) {
    window.location.href = url;
  }

  closeSkipForNowModal(event: any, modalAction: string) {
    if (event.key === 'Enter' || event.type === 'click'
      || event.keyCode === 13 || event.type === 'clicked outside') {
      this[modalAction] = 'close';
      this.modalCloseEvent.emit('modalClose');
    }
  }

}
